export default {
  statistics: {
    number_of_orders: '0',
    pabook: [
      {
        amount: '0',
        currency: 'USD',
      },
    ],
    reviewReadingStats: {
      percentageReading: 0,
      totalReading: 0,
    },
    reviewRequests: {
      completed: '0',
      completedPercentage: '0',
      opened: '0',
      openedPercentage: '0',
      sent: '0',
    },
    totalReviews: '0',
    loaded: false,
    importedReviews: {},
    widgetReviews: {},
  },
  influencedOrders: {
    items: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'purchase_timestamp',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
    },
  },
  couponInfluencedOrders: {
    items: [],
    couponsTotal: 0,
    totalPaid: 0,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'purchase_timestamp',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
    },
  },
  reviewsPerPeriod: {
    period: 'd',
    items: [],
  },
  reviewRequestsMonthlyStats: {
    months: 10,
    items: [],
  },
  dailyInfluencedOrderStats: [],
  dailyReviewStats: {
    loaded: true,
    data: [],
    rateForEmail: 0,
    rateForSms: 0,
    totalEmail: 0,
    totalImported: 0,
    totalSms: 0,
    totalWidgets: 0,
  },
  dailyReviewRequestStats: [],
  dailyCouponStats: [],
  dailyCouponInfluencedStats: [],
};
